module.exports = __webpack_public_path__ + "static/media/a35.4a4e3dae.pdf";